module.exports = __webpack_public_path__ + "static/04-d8504a8e35c92d492cf37b2fdc32f269.jpg";